import React from 'react';

// Konami code -> CLI terminal theme. The banner is rendered by App when `cli`
// is on. The other four eggs (command palette, %c console note, /uses
// colophon, the discoverable hint lines) live in App/CommandPalette.

const SEQ = [
  'ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown',
  'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight',
  'b', 'a',
];

export default function useEasterEggs() {
  const [cli, setCli] = React.useState(false);

  React.useEffect(() => {
    let i = 0;
    function onKey(e) {
      const k = e.key.length === 1 ? e.key.toLowerCase() : e.key;
      i = k === SEQ[i] ? i + 1 : k === SEQ[0] ? 1 : 0;
      if (i === SEQ.length) {
        i = 0;
        setCli((v) => !v);
      }
    }
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  React.useEffect(() => {
    document.body.classList.toggle('cli', cli);
  }, [cli]);

  // Keep React state in sync if the palette's "toggle theme" flips the class.
  React.useEffect(() => {
    const obs = new MutationObserver(() => {
      const has = document.body.classList.contains('cli');
      setCli((v) => (v === has ? v : has));
    });
    obs.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });
    return () => obs.disconnect();
  }, []);

  return { cli, banner: null };
}
